import { Component, Inject, OnInit, TemplateRef } from '@angular/core';
import { DeviceService } from '@services/device.service';
import { UserService } from '@services/user.service';
import { AppComponent } from 'app/app.component';
import { Authorization } from 'app/shared/classes/authorization';
import { CommonShared } from 'app/shared/classes/common';
import moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { KigSettings, KIG_SETTINGS } from 'settings/kig-settings';
import {EMPTY, from, Observable} from 'rxjs';
import { ChangeLogNotesParams, ChangeLogNotesComponent } from 'app/components/messages/changelog-notes/changelognotes.components';
import { Device, UserGroup, Task, DeviceMessageInfo } from '@models';
import { CloudFileStorage } from '@models/Device/CloudFileStorage.model';
import { FileStorageService } from '@services/fileStorage.service';


export interface UpgradeManagerParams {
  devices: Device[];
}


@Component({
  standalone: false,
  selector: 'app-upgrade-manager',
  templateUrl: './upgrade-manager.component.html',
  styleUrls: ['./upgrade-manager.component.scss']
})

export class UpgradeManagerComponent implements OnInit, UpgradeManagerParams {

  auth = new Authorization();
  common = new CommonShared();

  modalDragOn: boolean = false;

  devices: Device[] = [];
  userGroups: UserGroup[] = [];
  associatedUserGroups: UserGroup[] = [];
  updateBundles: CloudFileStorage[] = [];
  selectedUpdateBundle: CloudFileStorage;
  updateBundleSourceId: string = "0000000000";
  timer4ReadingUpdateMessages: any;
  timer4ReadingUpdateMessagesCounter: number;
  activeGateway: Device;
  numberOfDevicesSelected: number = 0;
  loadingUpdateBundleFileList: boolean = false;

  public updateBundleCols = [
    {field: 'name', header: 'Name', width: '50%'},
    {field: 'uploadDate', header: 'Upload Date', width: '40%'},
    {field: 'download', header: '', width: '5%'},
    {field: 'delete', header: '', width: '5%'}
  ];

  public pushUpdateCols = [
    {field: 'checked', header: '', width: '6%' },
    {field: 'name', header: 'Gateway Name', width: '40%'},
    {field: 'version', header: 'Version', width: '15%'},
    {field: 'status', header: 'Status', width: '39%'},
  ];

  public bundleDropDownSettings: any = {
    displayKey: 'name',
    search: true,
    height: '300px',
    placeholder: 'Select Update Bundle to deploy',
    noResultsFound: 'No results found',
    searchOnKey: 'name',
    searchPlaceholder: 'Search',
    limitTo: 0
  };

  logModalRef: BsModalRef;
  username = 'unknown';
  preEditObjectAsJSONString = '';
  changeLogNotes = '';

  readonly globalSwitch: boolean;


  constructor(public bsModalRef: BsModalRef, private toastr: ToastrService, private modalService: BsModalService, public _fileStorageService: FileStorageService,
    private deviceService: DeviceService, public global: AppComponent, private confirmationService: ConfirmationService,
    @Inject(KIG_SETTINGS) private settings: KigSettings, public _userService: UserService) {
    this.globalSwitch = global.globalSwitch;
  }


  ngOnInit(): void {
    this._userService.getCurrentUserEmailUsingAzureAD().subscribe(
      results => {
        this.username = results['value'];
        if (this.username != null && this.username !== '') {
          this.startUp();
        }
      },
      () => {
        this.toastr.error('Error unable to read current user\'s info');
      });
  }

  startUp(): void {
    // this.devices.forEach(x => {
    //   this.getGatewayUpdateMessage(x);
    // });
    this.getListOfUpdateBundles(this.updateBundleSourceId);
  }


  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }


  buildNewTask(deviceID: number, action: string, payload: string): Task {
    const task: Task = {
      taskID: -1,
      deviceID,
      clientID: this.common.generateUUID(),
      priority: 1,
      type: 1,
      action,
      payload,
      expireTimeSec: 87,
      taskWaitIntervalSec: 3,
      waitForResult: true
    };

    return task;
  }


  addNotes2ChangeLog() {
    this.changeLogNotes = '';
    
    const params: ChangeLogNotesParams = {
      changeLogNotes: this.changeLogNotes,
      userGroupId: 0,
      category: ''
    };

    var modalRef = this.modalService.show(ChangeLogNotesComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, class: 'modal-above-confirmdialog', initialState: params });
    modalRef.content.onChangeLogNotes.subscribe((value) => {
      this.changeLogNotes = value;
    });
  }
  

  bundleSelectedForUpload(fileEvent) {
    this.uploadFile2Cloud(fileEvent);
  }


  uploadFile2Cloud(files: FileList) {
    if (files.length < 1) return;

    let file: File = files[0];
    var formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name)

    this._fileStorageService.uploadFileToStorage(this.updateBundleSourceId, formData).subscribe(
      results => {
        this.toastr.success(results);
        this.postGatewayUpdateMessage(this.updateBundleSourceId, "Uploaded " + file.name);
        this.getListOfUpdateBundles(this.updateBundleSourceId);
      },
      err => {
        this.toastr.error('Error occurred while uploading file');
      });
  }


  onFileDownload(updateBundle: CloudFileStorage) {
    this._fileStorageService.downloadFileFromStorage(this.updateBundleSourceId, updateBundle.name).subscribe(
      results => {
        this.toastr.success('Completed successfully');
      },
      err => {
        this.toastr.error('Error occurred while trying to download this file');
      });
  }


  onFileDeleteConfirm(upgradeBundle: CloudFileStorage) {
    this.confirmationService.confirm({
      message: 'Please confirm that you want to delete the update bundle ' + upgradeBundle.name,
      key: 'cd',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.deleteFileFromStorage(upgradeBundle);
      },
      reject: () => {
      }
    });
  }


  deleteFileFromStorage(updateBundle: CloudFileStorage) {
    this._fileStorageService.deleteFileFromStorage(this.updateBundleSourceId, updateBundle.name).subscribe(
      results => {
        this.toastr.success('Completed successfully');
        this.getListOfUpdateBundles(this.updateBundleSourceId);
      },
      err => {
        this.toastr.error('Error occurred while trying to delete this file');
      });
  }


  getListOfUpdateBundles(sourceId: string) {
    this.loadingUpdateBundleFileList = true;
    this._fileStorageService.getListOfFilesForSource(sourceId).subscribe(
      results => {
        this.updateBundles = [];
        results.forEach(x => {
          var updateBundle: CloudFileStorage = {
            id: 0,
            name: x,
            uploadDate: undefined,
            fileCount: 0,
            checked: false
          }
          this.updateBundles.push(updateBundle);
          this.getUploadDate(updateBundle, this.updateBundleSourceId);
        });
        this.loadingUpdateBundleFileList = false;
      },
      err => {
        this.toastr.error('Error occurred while retrieving list of bundle update files');
        this.loadingUpdateBundleFileList = false;
      });
  }


  getUploadDate(updateBundle: CloudFileStorage, sourceId: string) {
    this.deviceService.getGatewayActivityMessages(sourceId, 20).subscribe(
      results => {
        var deviceMessageInfos: DeviceMessageInfo[] = results;
        var updateMessage = deviceMessageInfos.find(x => x.message == 'Uploaded ' + updateBundle.name);
        if (updateMessage != undefined) {
          var localDate = moment.utc(updateMessage.createdDate).local().toDate();
          updateBundle.uploadDate = localDate;
        }
      },
      err => {
        this.toastr.error("Error getting gateway update message");
      });
  }


  deviceSelected(device: Device) {
    if (device.checked) {
      this.getDeviceVersionInfo(device);
    }

    this.numberOfDevicesSelected = this.devices.filter(x => x.checked).length;
  }


  getDeviceVersionInfo(device: Device) {
    device.version = 'checking';
    const task = this.buildNewTask(device.id, '/bin/cat /home/pi/kigs/version.txt', '');
    this.deviceService.postTask(task, '', 4).subscribe(
      results => {
        if (results != undefined && results != null && results != '') {
          device.version = results;
        } else {
          device.version = '*';
        }
      },
      err => {
      });
  }


  startDeployingUpdateBundle() {
    var selectedDevices = this.devices.filter(x => x.checked);
    this.numberOfDevicesSelected = 0;

    selectedDevices.forEach(x => {
      this.deployBundle2Device(x, this.selectedUpdateBundle.name);
    });
  }


  deployBundle2Device(device: Device, updateBundleFilename: string) {
    device.lastUpdateMessage = '';
    device.previousUpdateMessage = '';

    this.postGatewayUpdateMessage(device.serialNumber, "-----");
    device.lastUpdateMessage = "Initiating bundle update";
    this.timer4ReadingUpdateMessagesCounter = 0;

    this.startTimer4ReadingUpdateMessages(device);

    const task = this.buildNewTask(device.id, '/home/pi/kigs/scripts/tasks/installUpdateBundle.sh ' + updateBundleFilename, '');
    this.deviceService.postTask(task, 'Initiating deployment', 4).subscribe(
      results => {
        this.toastr.success("Update sucessfully requested for " + device.name);
      },
      err => {
        this.toastr.error("Error requesting bundle update for " + device.name);
      });
  }


  postGatewayUpdateMessage(sourceId: string, message: string) {
    this.deviceService.postGatewayUpdateMessage(sourceId, message).subscribe(
      results => {
        if (results != undefined && results != '') {
          this.toastr.warning(results);
        }
      },
      err => {
        this.toastr.error("Error posting gateway update message");
      });
  }


  getGatewayUpdateMessage(device: Device) {
    this.deviceService.getGatewayActivityMessages(device.serialNumber, 20).subscribe(
      results => {
        var deviceMessageInfos: DeviceMessageInfo[] = results;
        if (deviceMessageInfos != undefined && deviceMessageInfos.length > 0) {
          device.previousUpdateMessage = device.lastUpdateMessage;
          device.lastUpdateMessage = deviceMessageInfos[0].message;
          if (device.previousUpdateMessage != device.lastUpdateMessage) {
            this.timer4ReadingUpdateMessagesCounter = 0;
          }

          deviceMessageInfos.forEach(x => {
            x.createdDate = moment.utc(x.createdDate).local().toDate();
          });
          device.updateMessages = deviceMessageInfos;
        }
      },
      err => {
        this.toastr.error("Error getting gateway update message");
      });
  }


  setActiveGateway(device: Device) {
    this.activeGateway = device;
  }


  startTimer4ReadingUpdateMessages(device: Device) {
    this.timer4ReadingUpdateMessages = setInterval(() => {
      if (this.timer4ReadingUpdateMessagesCounter > 60) {
        clearInterval(this.timer4ReadingUpdateMessages);
      }
      else {
        this.timer4ReadingUpdateMessagesCounter++;
        this.getGatewayUpdateMessage(device);
      }
    },2000);
  }


}
